import validate from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/middleware/auth.js")
}